import { getWhatsappChatsBetweenUsersUrl, getWhatsappChatsUrl, preProdToken, sendWhatsappMessagesUrl, sendWhatsappTemplateMessagesUrl, whatsappBulkChatHistoryUrl, whatsappMonitorContactsUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";
import axios from "axios";

export const getChats = async ({ search = "" }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    const response = await axios.get(getWhatsappChatsUrl + `?search=${search || ""}&page_size=20`, config);

    return response;
};

export const getChatBetweenUsers = async (phone) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    const response = await axios.get(getWhatsappChatsBetweenUsersUrl + phone + "/", config);

    return response;
};

export const sendWhatsappMessage = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    const response = await axios.post(sendWhatsappMessagesUrl, data, config);

    return response;
};

export const sendWhatsappTemplateMessage = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    const response = await axios.post(sendWhatsappTemplateMessagesUrl, data, config);

    return response;
};

// Admin WhatsApp Monitor: contacts of a tab (b2c | b2b | support) from our backend
export const getMonitorContacts = (tab) =>
    axios.get(whatsappMonitorContactsUrl, {
        headers: { "Authorization": `Token ${getUserToken()}` },
        params: { tab },
    });

// Chats for many numbers at once: `batchSize` numbers per call, 5 calls at a time.
// Returns { "91XXXXXXXXXX": [messages oldest first] }
export const getBulkChatHistory = async (phones, limitPerContact = 20, batchSize = 20) => {
    const config = { headers: { "Content-Type": "application/json", "Authorization": `Token ${preProdToken}` } };
    const batches = [];
    for (let i = 0; i < phones.length; i += batchSize) batches.push(phones.slice(i, i + batchSize));
    const out = {};
    for (let i = 0; i < batches.length; i += 5) {
        const results = await Promise.all(batches.slice(i, i + 5).map((contacts) =>
            axios.post(whatsappBulkChatHistoryUrl, { contacts, limit_per_contact: limitPerContact }, config)));
        results.forEach((res) => Object.assign(out, res.data));
    }
    return out;
};
